import { useGranite } from "@redux/modules/value/translations/translations.provider";
import { isDefined } from "@utils/helpers";
import { RefObject, useRef } from "react";
import { TooltipTemplate } from "../components/map/tooltip.template";
import { MARKER_OFFSET } from "../storeSearch.config";
import { findStoreUrl } from "../storeSearch.helpers";
import { StoreUrl } from "../storeSearch.types";
import { useMap } from "./useMap.hook";

const ceateInfoWindow = (onClose: () => void) => {
    const infoWindow = new woosmap.map.InfoWindow({});
    infoWindow.addListener("closeclick", onClose);

    return infoWindow
}

export const useInfoWindow = (mapElementRef: RefObject<HTMLDivElement>, storeUrls: StoreUrl[], onCloseClick: () => void) => {
    const { t } = useGranite();

    const infoWindowRef = useRef<woosmap.map.InfoWindow>(ceateInfoWindow(onCloseClick));

    const map = useMap(mapElementRef);

    const open = (storeGeoJSON: woosmap.map.stores.StoreResponse,) => {
        if (!isDefined(map)) return;

        infoWindowRef.current.setOffset(
            new woosmap.map.Point(0, MARKER_OFFSET),
        );

        infoWindowRef.current.setContent(
            TooltipTemplate(
                t,
                storeGeoJSON.properties,
                findStoreUrl(storeUrls, storeGeoJSON.properties.user_properties.storeId)
            ),
        );

        infoWindowRef.current.open(map, {
            lat: storeGeoJSON.geometry.coordinates[1],
            lng: storeGeoJSON.geometry.coordinates[0],
        });
    }

    const close = () => {
        infoWindowRef.current.close();
    }

    return {
        open: open,
        close: close,
    }
}
